import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { getDailyLossRewardsClaim, getLossReliefRewardsInfo } from '@/api/activity';
import { getActivityInformations } from '@/api/common';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { useUserStore } from '@/stores/user';
import LossFundReportOne from '@/themes/themeOne/lossReliefFunds/lossFundReport.vue';
import LossFundReportTwo from '@/themes/themeTwo/lossReliefFunds/lossFundReport.vue';
import { getDefaultRewards, getTodayData, sumAmounts } from '@/utils/commonFunction';
import { computed, onMounted, ref } from 'vue';
import { ConfigItem, DailyRewardData, FutureRewards, LossReliefData, PAGE_SIZE } from './supportScript';
import { useThemeStore } from '@/stores/theme';


export default /*@__PURE__*/_defineComponent({
  __name: 'lossFundReport',
  setup(__props) {

const themeStore = useThemeStore()
const userStore = useUserStore()
const loadingRef = ref()
const isSuccess = ref(false)
const statusRef = ref();
const toastContent = ref('');

const activityIntro = ref([])
const lossConfig = ref<ConfigItem[]>([])
const historyList = ref<DailyRewardData[]>([])
const weeklyRewardList = ref<DailyRewardData[]>([])
const futureRewards = ref<FutureRewards[]>([])
const todayBetDetails = ref<DailyRewardData>({
    createTime: '',
    day: 0,
    status: 0,
    dayOne: 0,
    dayTwo: 0,
    dayThree: 0,
    dayFour: 0,
    dayFive: 0,
    daySix: 0,
    daySeven: 0,
    availableAmount: 0,
    givenAmount: 0,
    rewards: [],
})
const total = ref()
const pageNum = ref(1)
const pageSize = ref(PAGE_SIZE)
const cashbackTotal = ref(0)
const dayCount = ref(0)
const bannerIcon = ref('')
const dataSet = computed<LossReliefData>(() => ({
    activityIntro: activityIntro.value,
    lossConfig: lossConfig.value,
    historyList: historyList.value,
    weeklyRewardList: weeklyRewardList.value,
    futureRewards: futureRewards.value,
    todayBetDetails: todayBetDetails.value,
    total: total.value,
    pageNum: pageNum.value,
    pageSize: pageSize.value,
    cashbackTotal: cashbackTotal.value,
    dayCount: dayCount.value,
    bannerIcon: bannerIcon.value
}))
const getActivityInfo = () => {
    loadingRef.value.open();
    let data = {
        activityId: "game_benefit"
    }
    getActivityInformations(data).then(res => {
        loadingRef.value.close();
        const tempObj = res.data;
        lossConfig.value = tempObj.config.loss_relief_config
        bannerIcon.value = tempObj.floatIcon
        activityIntro.value = JSON.parse(tempObj.activityIntro)
        if (weeklyRewardList.value.length <= 0) {
            dayCount.value = lossConfig.value.length
        }
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}

const getNextPageRewardData = () => {
    if (total.value > pageSize.value * pageNum.value) {
        loadingRef.value.open()
        pageNum.value = pageNum.value + 1
        getHistoryList()
    }
}

const getDailyLossRelief = () => {
    let data = {
        pageNum: pageNum.value,
        pageSize: 7,
    }
    getLossReliefRewardsInfo(data).then((res: any) => {
        loadingRef.value.close();
        weeklyRewardList.value = res.data.pageData.rows
        todayBetDetails.value = weeklyRewardList.value ? getTodayData(weeklyRewardList.value) : {}
        futureRewards.value = todayBetDetails.value ? todayBetDetails.value?.rewards : getDefaultRewards(dayCount.value)

        if (!todayBetDetails.value) {
            const today = new Date().toISOString().split('T')[0];
            let defaultData = {
                createTime: today + ' 00:00:00',
                day: 0,
                status: 0,
                dayOne: 0,
                dayTwo: 0,
                dayThree: 0,
                dayFour: 0,
                dayFive: 0,
                daySix: 0,
                daySeven: 0,
                availableAmount: 0,
                givenAmount: 0,
                rewards: []
            }
            todayBetDetails.value = defaultData
            futureRewards.value = getDefaultRewards(dayCount.value)
        }
        cashbackTotal.value = sumAmounts(futureRewards.value)
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}
const getHistoryList = () => {
    loadingRef.value.open();
    let data = {
        pageNum: pageNum.value,
        pageSize: pageSize.value,
    }
    getLossReliefRewardsInfo(data).then((res: any) => {
        historyList.value = [...historyList.value, ...res.data.pageData.rows]
        total.value = res.data.pageData.total
        loadingRef.value.close();
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const resetHistoryData = () => {
    total.value = 0
    pageNum.value = 1
    historyList.value = []
}

const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const getClaim = () => {
    loadingRef.value.open();
    let data = {
        uid: userStore.id
    }
    getDailyLossRewardsClaim(data).then((res: any) => {
        loadingRef.value.close();
        showSuccess(res.msg)
        loadingRef.value.open();
        getDailyLossRelief()
    }).catch(err => {
        loadingRef.value.close();
        showError(err);
    })
}
onMounted(() => {
    loadingRef.value.open()
    getActivityInfo()
    getDailyLossRelief()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(LossFundReportOne, {
            "data-set": dataSet.value,
            onGetClaim: getClaim,
            onGetHistoryList: getHistoryList,
            onGetNextPageRewardData: getNextPageRewardData,
            onResetHistoryData: resetHistoryData
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(LossFundReportTwo, {
            "data-set": dataSet.value,
            onGetClaim: getClaim,
            onGetHistoryList: getHistoryList,
            onGetNextPageRewardData: getNextPageRewardData,
            onResetHistoryData: resetHistoryData
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})